import API from "../../apiConfig";

export const fetchMarginUploads = async (data) => {
  const response = await API.get("margin/upload/list", { params: data }, null, true, true);
  return response;
};

export const uploadFile = async (data) => {
  const response = await API.post("v2/margin/upload", data, true, true);
  return response;
};

export const uploadMargin = async (data) => {
  const response = await API.post("v2/margin", data, true, true);
  return response;
};
